import request from '../../utils/request';

export function findAddress(params) {
  return request(`/address/find`, {
    method: 'POST',
    data: params,
  });
}
